import React from 'react'
import { 
  Header, 
  Footer, 
  Hero, 
  Features, 
  EmailCapture, 
  FloatingShapes 
} from '@components'

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 font-sans">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-cp-primary/10 via-cp-secondary/5 to-transparent"></div>
      </div>
      
      {/* Floating Background Elements */}
      <FloatingShapes />

      {/* Main Container */}
      <div className="relative min-h-screen flex flex-col">
        <Header />
        
        {/* Main Content */}
        <main className="flex-grow flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <Hero />
            <Features />
            <EmailCapture />
          </div>
        </main>
        
        <Footer />
      </div>
    </div>
  )
}

export default App